<template>
  <div class="sm:w-max">
    <div class="font-serif mb-4 resume-section-item rounded-t-full text-center
        dark:bg-winter-cyan dark:text-gray-900 px-8 py-6 4k:px-16 4k:py-12
        bg-summer-green text-li text-xs sm:text-sm fhd:text-lg 4k:text-4xl">
      <h1 class="font-bold">{{ 'courses-title' | lang('education') }}</h1>
      <h6 v-for="(item, index) in listCourses" :key="index">{{ item }}</h6>
    </div>
    <div class="font-serif mb-4 resume-section-item rounded-b-full text-center
        dark:bg-winter-cyan dark:text-gray-900 px-6 sm:px-14 py-4 4k:px-24 4k:py-14
        bg-summer-green text-li text-xs sm:text-sm fhd:text-lg 4k:text-4xl">
      <h6 v-for="(item, index) in listExtras" :key="index">{{ item }}</h6>
      <h1 class="font-bold">{{ 'extras-title' | lang('education') }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listExtras: this.$options.filters.lang('extras', 'education'),
      listCourses: this.$options.filters.lang('courses', 'education'),
    };
  },
}
</script>